/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import * as moment from "moment";
import i18next from "i18next";
import { useNavigate, useParams } from "react-router-dom";
import DocumentList from "./DocumentList";
import "react-tooltip/dist/react-tooltip.css";
import BoxList from "./components/BoxList";

import {
  DocumentListViewContainer,
  FlexRow,
  SectionContainer,
  ButtonData,
} from "./DocumentListView.styled";

/**
 * DocumentListView List,
 * Path - /documents
 * @see See [Document Requirements](https://hesusstore.atlassian.net/wiki/spaces/HS/pages/2944237576/Company+view+page+-+Documents)
 * @component
 */
const DocumentListView = (props) => {
  const {
    t,
    hesusBoxId,
    entityId,
    entityType,
    type,
    entityData,
    updateRefeshStatus,
  } = props;

  const [activeTab, setActiveTab] = useState("document");
  const [boxId, setsBoxId] = useState(hesusBoxId);

  const toggleTab = (tab) => {
    setActiveTab(tab);
  };

  return (
    <DocumentListViewContainer>
      <>
        <FlexRow>
          <SectionContainer>
            <FlexRow>
              <ButtonData
                marginRight="10px"
                color={activeTab === "document" ? "#008395" : "#cccccc"}
                onClick={() => toggleTab("document")}
              >
                {t("DOCUMENTS")}
              </ButtonData>

              <ButtonData
                marginRight="10px"
                color={activeTab === "box" ? "#008395" : "#cccccc"}
                onClick={() => toggleTab("box")}
              >
                {t("BOX")}
              </ButtonData>
            </FlexRow>
            {activeTab === "document" && (
              <DocumentList
                entityId={entityId}
                entityType={entityType}
                entityData={entityData}
              />
            )}
            {activeTab === "box" && (
              <BoxList
                boxId={boxId}
                setsBoxId={setsBoxId}
                entityId={entityId}
                entityType={entityType}
                type={type}
                updateRefeshStatus={updateRefeshStatus}
              />
            )}
          </SectionContainer>
        </FlexRow>
      </>
    </DocumentListViewContainer>
  );
};

DocumentListView.propTypes = {
  t: PropTypes.func.isRequired,
  entityId: PropTypes.number.isRequired,
  entityType: PropTypes.string.isRequired,
  type: PropTypes.number.isRequired,
  hesusBoxId: PropTypes.number,
  updateRefeshStatus: PropTypes.func,
};

DocumentListView.defaultProps = {
  hesusBoxId: null,
  updateRefeshStatus: () => {},
};

export default withTranslation()(DocumentListView);
